import request from '../utils/http'
// 班级信息
export function index (query) {
  return request({
    url: '/classes/list',
    method: 'GET',
    params: query
  })
}
// 新增班级
export function save (query) {
  return request({
    url: '/classes/save',
    method: 'POST',
    data: query
  })
}
// 编辑班级
export function edit (query) {
  return request({
    url: '/classes/edit',
    method: 'GET',
    params: query
  })
}
// 更新班级
export function update (query) {
  return request({
    url: '/classes/update',
    method: 'POST',
    data: query
  })
}
// 删除班级
export function del (query) {
  return request({
    url: '/classes/delete',
    method: 'DELETE',
    data: query
  })
}
// 机构信息
export function mechanism (query) {
  return request({
    url: '/mechanism/list?limit=500',
    method: 'GET',
    params: query
  })
}
// 导出班级数据
export function campusExport (query) {
  return request({
    url: '/classes/export',
    method: 'POST',
    responseType: 'blob',
    data: query
  })
}
// 校区信息
export function campusList (query) {
  return request({
    url: '/campus/list?limit=500',
    method: 'GET',
    params: query
  })
}
// 学生列表
export function studentList (query) {
  return request({
    url: '/student/list?limit=500',
    method: 'GET',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/classes.js